import {
  Building2, Activity, AlertTriangle, Clock,
  Users, CheckSquare,
} from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip'

interface KPIData {
  total_obras: number
  obras_ativas: number
  pendencias_abertas: number
  rdos_mes: number
  fvs_aprovadas: number
  ocorrencias_abertas: number
}

interface Props {
  data: KPIData
  onNavigate: (path: string) => void
}

export default function DashboardKPIs({ data, onNavigate }: Props) {
  const cards = [
    { lbl: 'Total de Obras', val: data.total_obras, cor: 'var(--sky)', ico: <Building2 size={14} />, tip: 'Total de obras cadastradas', path: '/obras' },
    { lbl: 'Obras Ativas', val: data.obras_ativas, cor: 'var(--amber)', ico: <Activity size={14} />, tip: 'Obras com status "Em Execução"', path: '/obras' },
    { lbl: 'Pendências Abertas', val: data.pendencias_abertas, cor: data.pendencias_abertas > 0 ? 'var(--rose)' : 'var(--emerald)', ico: <Clock size={14} />, tip: 'Pendências abertas no momento', path: '/pendencias' },
    { lbl: 'RDOs no Mês', val: data.rdos_mes, cor: 'var(--sky)', ico: <Users size={14} />, tip: 'Diários de obra registrados no mês atual', path: '/diario-obra' },
    { lbl: 'FVS Aprovadas', val: data.fvs_aprovadas, cor: 'var(--emerald)', ico: <CheckSquare size={14} />, tip: 'FVS com status aprovado', path: '/fvs' },
    { lbl: 'Ocorrências Abertas', val: data.ocorrencias_abertas, cor: data.ocorrencias_abertas > 0 ? 'var(--rose)' : 'var(--emerald)', ico: <AlertTriangle size={14} />, tip: 'Ocorrências ainda não resolvidas', path: '/ocorrencias' },
  ]

  return (
    <TooltipProvider>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {cards.map((k, i) => (
          <Tooltip key={i}>
            <TooltipTrigger asChild>
              <div
                className="kpi-card cursor-pointer hover:brightness-95 transition-all"
                data-testid="kpi-card"
                onClick={() => onNavigate(k.path)}
              >
                <div className="flex items-center gap-1.5 mb-2">
                  <span style={{ color: `hsl(${k.cor})` }}>{k.ico}</span>
                  <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">{k.lbl}</span>
                </div>
                <div className="text-2xl font-extrabold" style={{ color: `hsl(${k.cor})` }}>{k.val}</div>
              </div>
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <p className="text-xs max-w-[200px]">{k.tip}</p>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  )
}
